export default __webpack_public_path__ + "static/media/nomasse-w.96f5f16e.svg";